/**
 * Route for `customizable-table-columns-per-view`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomizableTableColumnsPerViewPage } from "../features/customizable-table-columns-per-view/CustomizableTableColumnsPerViewPage";

export const customizableTableColumnsPerViewRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/customizable-table-columns-per-view",
	component: CustomizableTableColumnsPerViewPage,
});

export default customizableTableColumnsPerViewRoute;
